module.exports = __webpack_public_path__ + "media/components/slider/s2-62cdeed7879ae7bfbd3511469fcf1d73.jpg";